import * as React from 'react';
import { titleCase } from '@shapeable/utils';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultEntityTypeLabelsSet = {
  "PdfFileAsset": "PDF Document",
  "WordFileAsset": "Word Document",
  "ExcelFileAsset": "Excel Spreadsheet"
};
export var EntityTypeLabelsContext = React.createContext(defaultEntityTypeLabelsSet);
export var EntityTypeLabelsProvider = createInheritedProvider(EntityTypeLabelsContext);
export var useEntityTypeLabel = function (entityTypeName, fallback) {
  if (fallback === void 0) {
    fallback = false;
  }
  var labels = React.useContext(EntityTypeLabelsContext);
  var label = labels[entityTypeName];
  return label || (fallback ? titleCase(entityTypeName) : '');
};
export var useEntityTypeLabels = function () {
  return React.useContext(EntityTypeLabelsContext);
};